<template>
  <div class="views">
    <b-modal :active.sync="$store.getters.modalEdificio" :width="640">
      <div class="modal-card" style="width: 400px">
          <header class="modal-card-head">
            <p class="modal-card-title">Agregar Edificio</p>
          </header>
          <section class="modal-card-body">
            <b-field label="Nombre de Edificio">
              <b-input
                class="input-custom input-custom--views"
                type="text"
                v-model="newEdificio.nombre"
                placeholder="Nombre Edificio"
                required>
              </b-input>
            </b-field>
            <b-field label="Dirección">
              <b-input
                class="input-custom input-custom--views"
                type="text"
                v-model="newEdificio.direccion"
                placeholder="Dirección"
                required>
              </b-input>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <button class="button ripple button-custom button-custom--cancel" type="button" @click="cancelarEdificio()">Cancelar</button>
            <button class="button ripple button-custom button-custom--confirm" @click="addNewBuilding(newEdificio)">Guardar Nuevo Edificio</button>
          </footer>
        </div>
    </b-modal>
    <router-view/>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { service } from "@/helper/Rest";
export default {
  name: "Views",
  data() {
    return {
      option: ["Activo", "Inactivo"],
      newEdificio: {
        nombre: "",
        estado: "",
        direccion: ""
      },
      newTarea: {
        nombre: "",
        descripcion: ""
      },
      newEdificioWarning: false,
      newTareaWarning: false
    };
  },
  created(){
  },
  methods: {
    ...mapMutations(["addBuilding", "addTask"]),
    addNewBuilding: function(obj) {
      if (obj.nombre && obj.direccion && this.$store.state.companyId) {
        service
          .postEdificios(obj, this.$store.state.companyId, this.$store.state.namespace)
          .then(response => {
            this.addBuilding(response.data);
            this.$store.commit("changeModal", "edificio");
            this.newEdificio = {
              nombre: "",
              direccion: "",
            };
            this.newEdificioWarning = false;
            this.$toast.open({
              message: "Edificio agregado",
              position: "is-bottom-right",
              type: "ffcolor-is-success"
            });
          })
          .catch(error => {
            console.warn(error);
          });
      } else {
        this.newEdificioWarning = true;
      }
    },
    cancelarEdificio: function() {
      this.newEdificioWarning = false;
      this.newEdificio = {
        nombre: "",
        direccion: ""
      };
      this.$store.commit("changeModal", "edificio");
    }
  }
};
</script>
<style lang="scss" >
// @import "../../assets/styles/6.components/index";
// @import "../../assets/styles/4.elements/index";
@import "../../assets/styles/2.tools/mixins/_mediaquerys.scss";
.views {
  position: relative;
  top: 0;
  left: 0;
  // overflow-y: auto;
  width: 100%;
  margin-left: 0;
  .modal-view {
    // width: 80%;
    left: 0;
  }

  @include media-xl {
    margin-left: 330px;
  }
  .button-custom {
    // border-radius: 4px;
    &--cancel {
      flex: 1;
      color: #363636;
      background-color: white;
    }
    &--confirm {
      flex: 1;
      background-color: #1abc9c;
    }
  }
}
.input-custom{
  &--views{
    &:focus{
      border-color: #ff3860;
    }
    .input{
      &:focus{
        box-shadow: none;
      }
    }
    .icon{
      color: #ff3860 !important;
    }
  }
}
.modal-card{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/Views.vue